'use client'
import { useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import dynamic from 'next/dynamic'

const Desktop = dynamic(() => import('./responsive/desktop'))
const Mobile = dynamic(() => import('./responsive/mobile'))

const Stories = ({ isLanding = false }: { isLanding?: boolean }) => {
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )
  return isDesktop ? <Desktop isLanding={isLanding} /> : <Mobile />
}

export default Stories
